//
export const appData = {
  app_version: '3.48.1-38-gbc27585',
  branch: 'pipelines/1144683365',
  build_number: 6187
};

